/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APP_CONFIG} from '../app.config';
import {MessageService} from "./message.service";
import {EmployeeType} from "../model/employee-type";
import {Observable, of} from "rxjs";
import {catchError, tap} from "rxjs/operators";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class EmployeeTypeService {

  private baseUrl

  constructor(private http: HttpClient,
              private messageService: MessageService) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api';

  }


  getEmployeeTypeById(employeeType: EmployeeType | number): Observable<EmployeeType> {
    const id = typeof employeeType === 'number' ? employeeType : employeeType.employeeTypeId;
    const url = `${this.baseUrl}/employeetypes/${id}`;

    return this.http.get<EmployeeType>(url, httpOptions).pipe(
      tap(_ => this.log('got employee type "${getEmployeeType}"')),
      catchError(this.handleError<EmployeeType>('getEmployeeType'))
    );
  }

  getAllEmployeeTypes(): Observable<EmployeeType[]> {
    const url = `${this.baseUrl}/employeetypes/all`;

    return this.http.get<EmployeeType[]>(url, httpOptions).pipe(
      tap(_ => this.log('got employee type "${getAllEmployeeType}"')),
      catchError(this.handleError<EmployeeType[]>('getAllEmployeeType'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the MessageService */
  private log(message: string) {
    this.messageService.add('GmPerson: ' + message);
  }
}

